import styled from 'styled-components';
import { Color, BorderRadius, Padding } from '../../types';
import {
  applyBackgroundColor,
  applyBorderRadius,
  applyPadding,
} from '../../utils';

export type ContainerProps = {
  $backgroundColor?: Color;
  $borderRadius?: BorderRadius;
  padding?: Padding;
};

export const Container = styled.div<ContainerProps>`
  ${applyBackgroundColor}
  ${applyBorderRadius}
  ${applyPadding}
  height: fit-content;
  width: fit-content;
`;
